/* =========================================================================
   Selin Beauty — Sepette tamamlayıcı ürünler (çapraz satış / AOV)
   -------------------------------------------------------------------------
   Kampanya kodundan (sb-kampanya.js) BAĞIMSIZDIR; kampanya kapalıyken de
   çalışır. Ürünler Shopify'ın kendi öneri ucundan gelir:

     intent=complementary → Search & Discovery uygulamasında elle tanımlanan
                            tamamlayıcı ürünler (varsa bunlar öncelikli)
     intent=related       → tanım yoksa otomatik ilgili ürünler (yedek)

   Sepette zaten bulunan ürünler listeden çıkarılır.
   ========================================================================= */
(function () {
  'use strict';

  var CFG = { moneyFormat: '{{amount}} TL', limit: 10 };
  var kok = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var mesgul = false;

  function ayarlariOku() {
    var el = document.getElementById('sb-tamamlayici-config');
    if (!el) return;
    try {
      var d = JSON.parse(el.textContent);
      if (d.moneyFormat) CFG.moneyFormat = d.moneyFormat;
      if (d.limit) CFG.limit = d.limit;
    } catch (e) {
      /* varsayılanlarla devam */
    }
  }

  /**
   * Kuruş cinsinden tutarı mağazanın kendi para biçimiyle yazar.
   * Tema `shop.money_format` içinde {{amount}} / {{amount_with_comma_separator}}
   * gibi yer tutucular kullanır; ikisini de destekliyoruz.
   */
  function paraYaz(kurus) {
    var n = Number(kurus || 0) / 100;
    var nokta = n.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    var virgul = n.toLocaleString('de-DE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    return CFG.moneyFormat
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, virgul.split(',')[0])
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, virgul)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, nokta.split('.')[0])
      .replace(/\{\{\s*amount\s*\}\}/g, nokta);
  }

  function kacis(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function json(url) {
    return fetch(url, { headers: { Accept: 'application/json' } }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    });
  }

  /* ------------------------------------------------------------- veri ---- */

  function sepetiAl() {
    return json(kok + 'cart.js');
  }

  function onerileriAl(urunId, niyet) {
    var u =
      kok +
      'recommendations/products.json?product_id=' +
      encodeURIComponent(urunId) +
      '&limit=' +
      CFG.limit +
      '&intent=' +
      niyet;
    return json(u)
      .then(function (d) {
        return (d && d.products) || [];
      })
      .catch(function () {
        return [];
      });
  }

  /**
   * Sepetteki ürünlerden yola çıkarak öneri toplar.
   * Önce complementary denenir; hiç sonuç yoksa related'a düşülür.
   * Sepette zaten olan ürünler ve tekrarlar ayıklanır.
   */
  function onerileriTopla(sepet) {
    var satirlar = (sepet && sepet.items) || [];
    if (satirlar.length === 0) return Promise.resolve([]);

    // En fazla 3 ürün için sorgu — daha fazlası sepet sayfasını yavaşlatır.
    var kaynaklar = [];
    for (var i = 0; i < satirlar.length && kaynaklar.length < 3; i++) {
      if (satirlar[i].product_id) kaynaklar.push(satirlar[i].product_id);
    }
    var sepettekiler = {};
    satirlar.forEach(function (l) {
      sepettekiler[l.product_id] = true;
    });

    function turDene(niyet) {
      return Promise.all(
        kaynaklar.map(function (id) {
          return onerileriAl(id, niyet);
        }),
      ).then(function (gruplar) {
        var gorulen = {};
        var out = [];
        gruplar.forEach(function (g) {
          g.forEach(function (p) {
            if (!p || !p.id) return;
            if (sepettekiler[p.id]) return; // sepette zaten var
            if (gorulen[p.id]) return; // tekrar
            if (p.available === false) return; // stokta yok
            gorulen[p.id] = true;
            out.push(p);
          });
        });
        return out;
      });
    }

    return turDene('complementary').then(function (liste) {
      if (liste.length > 0) return liste;
      // Tanımlı tamamlayıcı ürün yoksa otomatik ilgili ürünlere düş.
      return turDene('related');
    });
  }

  /* ------------------------------------------------------------ çizim ---- */

  function kartMarkup(p) {
    var v = (p.variants || []).filter(function (x) {
      return x && x.available !== false;
    })[0] || (p.variants || [])[0];
    if (!v) return '';

    var gorsel = p.featured_image || (p.images && p.images[0]) || null;
    var out = '<div class="sb-gift-card">';
    if (gorsel) {
      out +=
        '<img class="sb-gift-card__img" src="' +
        kacis(gorsel) +
        '" alt="" loading="lazy" width="120" height="120">';
    }
    out += '<div class="sb-gift-card__body">';
    out += '<a class="sb-gift-card__title sb-comp-card__link" href="' + kacis(kok + 'products/' + p.handle) + '">' + kacis(p.title) + '</a>';
    out += '<span class="sb-comp-card__price">' + kacis(paraYaz(p.price)) + '</span>';
    out += '</div>';
    out +=
      '<button type="button" class="sb-gift-card__btn" data-sb-comp-ekle="' +
      kacis(v.id) +
      '">Sepete Ekle</button>';
    out += '</div>';
    return out;
  }

  function noktalariKur(liste) {
    var kap = liste.closest('.sb-carousel');
    if (!kap) return;
    var dots = kap.querySelector('[data-sb-comp-dots]');
    var sol = kap.querySelector('[data-sb-comp-kaydir="-1"]');
    var sag = kap.querySelector('[data-sb-comp-kaydir="1"]');

    var kaydirmaVar = liste.scrollWidth > liste.clientWidth + 4;
    if (dots) dots.hidden = !kaydirmaVar;
    if (sol) sol.hidden = !kaydirmaVar;
    if (sag) sag.hidden = !kaydirmaVar;
    if (!kaydirmaVar) {
      if (dots) dots.innerHTML = '';
      return;
    }

    var kartlar = liste.querySelectorAll('.sb-gift-card');
    if (dots && dots.childElementCount !== kartlar.length) {
      var h = '';
      for (var i = 0; i < kartlar.length; i++) h += '<span class="sb-dot"></span>';
      dots.innerHTML = h;
    }

    function guncelle() {
      var kart = liste.querySelector('.sb-gift-card');
      if (!kart) return;
      var adim = kart.offsetWidth + 10;
      var aktif = Math.round(liste.scrollLeft / adim);
      if (dots) {
        dots.querySelectorAll('.sb-dot').forEach(function (d, i) {
          d.classList.toggle('is-active', i === aktif);
        });
      }
      if (sol) sol.disabled = liste.scrollLeft <= 2;
      if (sag) sag.disabled = liste.scrollLeft + liste.clientWidth >= liste.scrollWidth - 2;
    }
    guncelle();

    if (!liste.dataset.sbCompBagli) {
      liste.dataset.sbCompBagli = '1';
      var raf = null;
      liste.addEventListener(
        'scroll',
        function () {
          if (raf) return;
          raf = requestAnimationFrame(function () {
            raf = null;
            guncelle();
          });
        },
        { passive: true },
      );
    }
  }

  function ciz(urunler) {
    var bolum = document.querySelector('[data-sb-comp]');
    var liste = document.querySelector('[data-sb-comp-list]');
    if (!bolum || !liste) return;

    if (!urunler || urunler.length === 0) {
      // Önerilecek ürün yoksa bölüm hiç görünmez (boş kutu bırakma).
      bolum.hidden = true;
      liste.innerHTML = '';
      return;
    }

    liste.innerHTML = urunler
      .map(kartMarkup)
      .filter(function (h) {
        return h;
      })
      .join('');
    bolum.hidden = false;
    noktalariKur(liste);
  }

  function tazele() {
    return sepetiAl()
      .then(onerileriTopla)
      .then(ciz)
      .catch(function () {
        var b = document.querySelector('[data-sb-comp]');
        if (b) b.hidden = true;
      });
  }

  /* ------------------------------------------------------------- init ---- */

  function sepetSayfasi() {
    return window.location.pathname.split('?')[0].indexOf('/cart') === 0;
  }

  function init() {
    if (!sepetSayfasi()) return;
    if (!document.querySelector('[data-sb-comp]')) return;
    ayarlariOku();

    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;

      // şerit okları
      var ok = e.target.closest('[data-sb-comp-kaydir]');
      if (ok) {
        e.preventDefault();
        var kap = ok.closest('.sb-carousel');
        var liste = kap && kap.querySelector('[data-sb-comp-list]');
        if (liste) {
          var kart = liste.querySelector('.sb-gift-card');
          var adim = kart ? kart.offsetWidth + 10 : liste.clientWidth * 0.8;
          liste.scrollBy({
            left: adim * (Number(ok.getAttribute('data-sb-comp-kaydir')) || 1),
            behavior: 'smooth',
          });
        }
        return;
      }

      // sepete ekle
      var btn = e.target.closest('[data-sb-comp-ekle]');
      if (!btn || mesgul) return;
      e.preventDefault();
      var vid = parseInt(btn.getAttribute('data-sb-comp-ekle'), 10);
      if (!vid) return;
      mesgul = true;
      btn.disabled = true;
      btn.textContent = 'Ekleniyor…';
      fetch(kok + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] }),
      })
        .then(function (r) {
          return r.json();
        })
        .then(function () {
          // Sepet toplamı ve satırlar sunucudan gelmeli; sayfayı tazele.
          window.location.reload();
        })
        .catch(function () {
          mesgul = false;
          btn.disabled = false;
          btn.textContent = 'Sepete Ekle';
        });
    });

    tazele();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
